import { Component, Input, OnInit } from '@angular/core';
import { CurrencyService } from 'src/app/util/currency.service';
@Component({
  selector: 'app-invoice-card',
  templateUrl: './invoice-card.component.html',
  styleUrls: ['./invoice-card.component.css'],
})
export class InvoiceCardComponent implements OnInit {
  @Input() cardTitle: string = '';
  @Input() cardValue: number | string = '';
  @Input() previousValue: string = '';
  @Input() valueChanged: string = '';
  @Input() toolTipTitle: string = '';
  @Input() cashBalance: string = '';
  @Input() btnText: string = '';
  @Input() coloridx: number =  1;
  @Input() btnClicked: () => void;

  currency: string = '';
  isAmount: boolean = true;
  isNegativeValue: boolean;
  borderColor: string = '';

  constructor(private _currencyService: CurrencyService) {
    this.currency = this._currencyService.getCurrency();
  }

  ngOnInit(): void {
    this.initView();
  }

  handleBtnClick() {
    this.btnClicked();
  }

  private initView(): void {
    this.getBorderColor();
    if (typeof this.cardValue === 'number') {
      this.isAmount = false;
    }
  }

  isNegative(data) {
    return data?.toString()?.charAt(0) === '-';
  }

  private getBorderColor(): void {
    const colors: string[] = ['#8833FF', '#33BFFF', '#FFCB33', '#B658C5'];
    this.borderColor = colors[this.coloridx - 1] || colors[0];
  }
}
